import { render } from "./TemplateItemFormulaModal.vue?vue&type=template&id=b74e419c&scoped=true"
import script from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"
export * from "./TemplateItemFormulaModal.vue?vue&type=script&lang=js"

import "./TemplateItemFormulaModal.vue?vue&type=style&index=0&id=b74e419c&scoped=true&lang=less"

import exportComponent from "D:\\cwzl\\four-cw-net\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b74e419c"]])

export default __exports__